import React from "react";

import { Box, Typography, TextField } from "@mui/material";

import SelectProject from "./SelectProject";

interface ProjectAndDetailsProps {
  name: string;
  nameError: boolean;
  handleEpisodeNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedProject: { label: string; id: string } | null;
  handleProject: (
    event: React.SyntheticEvent,
    data: { label: string; id: string },
  ) => void;
  projectSelectionError: boolean;
}

export default function ProjectAndDetails({
  name,
  nameError,
  handleEpisodeNameChange,
  selectedProject,
  handleProject,
  projectSelectionError,
}: ProjectAndDetailsProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h5"
        sx={{
          mb: 3,
          textAlign: "center",
          color: "#23272E",
          fontWeight: 700,
        }}
      >
        Episode Details
      </Typography>

      {/* Episode Name */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, color: "#23272E", fontWeight: 600 }}
        >
          Episode Name
        </Typography>
        <TextField
          fullWidth
          label="Episode Name"
          value={name}
          onChange={handleEpisodeNameChange}
          error={nameError}
          helperText={nameError ? "Episode name is required" : ""}
          placeholder="Enter episode name..."
          inputProps={{
            "data-testid": "episode-name-input",
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              "&:hover fieldset": {
                borderColor: "#1976d2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
              },
            },
          }}
        />
      </Box>

      {/* Project Selection */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, color: "#23272E", fontWeight: 600 }}
        >
          Select Project
        </Typography>
        <SelectProject
          handleOnChange={handleProject}
          hasError={projectSelectionError}
          value={selectedProject}
        />
      </Box>
    </Box>
  );
}
